import { inject, Injectable } from '@angular/core';
import { MarkdownService } from 'ngx-markdown';
import { ImageApi } from '../data/images/image.api';
import { ImageViewerComponent } from '../app/image-viewer/image-viewer.component';
import { ModalController } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({providedIn: 'root'})
export class MarkdownRendererService {
  private markdownService = inject(MarkdownService);
  private imageApi = inject(ImageApi);
  private modalController = inject(ModalController);

  constructor() {
    this.setUpMarkdownImageRenderer();
  }

  setUpMarkdownImageRenderer() {
    this.markdownService.renderer.image = (href, title, text) => {
      console.log({href, title, text})
      if (href) {

        // just for my legacy images from firebase
        if (href.split('.').length === 1) {
          href = `${href}.jpg`
        }

        const copyToClipBoardButton = document.createElement('button');
        copyToClipBoardButton.className = 'entry-file-wrapper__copy_button'
        copyToClipBoardButton.innerHTML = 'copy'
        copyToClipBoardButton.onclick = () => {
          navigator.clipboard.writeText(`![Bild](${href})`)
        }

        const fileType = href.split('.')[1];

        this.imageApi.createSignedUrl(href).then(signedUrl => {

          if (signedUrl) {
            const fileWrapperEl = document.createElement('div');
            fileWrapperEl.className = 'entry-file-wrapper';

            if (fileType === 'mp4') {
              const videoEl = document.createElement('video');
              videoEl.controls = true
              const videoSourceEl = document.createElement('source');
              videoSourceEl.src = signedUrl;
              videoEl.appendChild(videoSourceEl);
              fileWrapperEl.appendChild(videoEl);

            } else if (fileType === 'mp3') {
              const audioEl = document.createElement('audio');
              audioEl.controls = true
              const videoSourceEl = document.createElement('source');
              videoSourceEl.src = signedUrl;
              audioEl.appendChild(videoSourceEl);
              fileWrapperEl.appendChild(audioEl);

            } else {
              const imageEl = document.createElement('img');
              imageEl.src = signedUrl;
              imageEl.onclick = () => this.openImageViewer(signedUrl);
              fileWrapperEl.appendChild(imageEl);
            }
            fileWrapperEl.appendChild(copyToClipBoardButton);
            const placeholderEl = document.getElementsByClassName(`file-${href}`)[0] as HTMLImageElement;
            placeholderEl.replaceWith(fileWrapperEl);
          }
        })

      }


      return `<div class="file-${href}"></div>`
    }
  }

  openImageViewer(url: string | undefined) {
    this.modalController.create({
      component: ImageViewerComponent,
      componentProps: {url},
      cssClass: 'image-viewer'
    }).then(modal => modal.present());
  }
}
